// extracted by mini-css-extract-plugin
module.exports = {"curtain":"video-gallery_curtain__w4zJo","fadeIn":"video-gallery_fadeIn__ATCvy","gradientBox":"video-gallery_gradientBox__3Rp6V","section":"video-gallery_section__NVMfH"};